import { Component } from "react";
import { Logo } from "@/components/Logo";

/** A learner should never be shown a white screen. */
export class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("Unbound crashed:", error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-screen grain flex items-center justify-center px-4" data-testid="error-boundary">
        <div className="relative z-10 w-full max-w-md text-center">
          <div className="flex justify-center">
            <Logo size="md" testId="error-logo" />
          </div>
          <h1 className="mt-8 text-3xl font-extrabold">Something broke on our side</h1>
          <p className="mt-3 text-sm text-slate-500">
            Not your fault, and nothing you've learned is lost. Reloading usually clears it.
          </p>
          <button
            data-testid="error-reload"
            onClick={() => window.location.assign("/")}
            className="mt-8 px-6 py-3 rounded-full bg-slate-900 text-white font-semibold hover:bg-slate-800 transition-colors"
          >
            Take me back
          </button>
        </div>
      </div>
    );
  }
}
